// JsFromRoutes CacheKey 23d66d648e3f5a5d816da4fbfe2a6766
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/employers/consistent_deductions'),
}
